import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import tWithDefault from 'parog-web/helpers/t-with-default';

interface Signature {
  Args: {
    Dropdown?: unknown;
    form: ProviderSig['Blocks']['content'][0];
  };
}

const ppsSections = {
  observance: [
    'treatment-taken',
    'bio-exams-done',
    'medicines-reconciliation',
    'therapeutic-education'
  ],
  'physical-health': [
    'gynecologist-consultation',
    'doctor-consultation',
    'diabetologist-consultation',
    'cardiologist-consultation',
    'nephrologist-consultation',
    'neurologist-consultation',
    'weight-measured',
    'blood-pressure-measured'
  ],
  'psychiatric-health': [
    'psychiatrist-consultation',
    'addictologist-consultation',
    'psychologist-consultation',
    'group-psychotherapy',
    'crisis-plan-follow-up'
  ],
  'life-hygiene': ['sleep', 'physicalActivity', 'food', 'drugs', 'stress'],
  'socio-professional': ['jobCoach', 'socialAssistant']
} as const;

const ConsultationReportFormContentPpsSectionsComponent: TemplateOnlyComponent<Signature> =
  <template>
    <div class='field'>
      <@form.Dropdown
        @allowAdditions={{true}}
        @labelName='Actions du PPS réalisées'
        @propertyName='actionsCarriedOut'
        @multipleSelection={{true}}
      >
        {{#each-in ppsSections as |section actions|}}
          <div class='ui tiny centered header'>{{t
              (concat 'monitoringPointReport.ppsSections.name.' section)
            }}</div>

          {{#each actions as |act|}}
            <div class='item'>
              {{tWithDefault
                (concat 'monitoringPointReport.ppsSections.actions.' act)
                act
              }}
            </div>
          {{/each}}

          <div class='divider'></div>
        {{/each-in}}
      </@form.Dropdown>
      <span class='placeholder-label'>
        Ajoutez ici les éléments du plan de soin qui ont été correctement suivis
        par le patient, depuis le dernier point de suivi.
      </span>
    </div>
  </template>;

export default ConsultationReportFormContentPpsSectionsComponent;
